import { useCallback, useEffect, useMemo, useState } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import CountryFlag from 'ui-addon-i18n/components/CountryFlag';
import UIWizardStep from 'UIComponents/dialog/UIWizardStep';
import Small from 'UIComponents/elements/Small';
import { H2 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UISelect from 'UIComponents/input/UISelect';
import UIFlex from 'UIComponents/layout/UIFlex';
import * as Countries from 'marketplace-ui-common/constants/Country';
import { COUNTRY } from '../../../constants/search/FilterKey';
/* @ts-expect-error module is untyped */
import { translateFilterValue } from '../../../utils/i18n';
import { WIZARD_STEP_CLASSNAME, WIZARD_STEP_HEIGHT } from '../../../constants/Wizard';
/* @ts-expect-error module is untyped */
import { OfficeLocationType } from '../../../constants/search/Filters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const unavailableCountryCodes = ['AN', 'AP'];
export default function FindPartnerWizardCountryStep({
  filters,
  onFilterChange,
  userInsights
}) {
  const [guessed, setGuessed] = useState(null);
  const handleFilterChange = useCallback((value, isGuess) => {
    onFilterChange('country', value);
    setGuessed(isGuess);
  }, [onFilterChange]);
  useEffect(() => {
    if (!filters.country && guessed === null) {
      const guess = (userInsights === null || userInsights === void 0 ? void 0 : userInsights.portalInsights.hqCountry) || (userInsights === null || userInsights === void 0 ? void 0 : userInsights.ipCountry);
      handleFilterChange(guess || 'ANY', !!guess);
    }
  }, [guessed, filters.country, handleFilterChange, userInsights]);
  const options = useMemo(() => {
    const optionsArr = Object.keys(Countries).map(option => ({
      avatar: unavailableCountryCodes.includes(option) ? undefined : /*#__PURE__*/_jsx(CountryFlag, {
        countryCode: option
      }),
      text: translateFilterValue(COUNTRY, option),
      value: option
    }));
    optionsArr.unshift({
      icon: 'language',
      text: unescapedText('ecosystem-marketplace-solutions-ui.homepage.questionnaire.country.default'),
      value: 'ANY'
    });
    return optionsArr;
  }, []);
  return /*#__PURE__*/_jsxs(UIWizardStep, {
    className: WIZARD_STEP_CLASSNAME,
    style: {
      height: WIZARD_STEP_HEIGHT
    },
    children: [/*#__PURE__*/_jsx(H2, {
      className: "m-bottom-11",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.country.title"
      })
    }), /*#__PURE__*/_jsx(UISelect, {
      anchorType: "combined",
      options: options,
      onChange: ({
        target: {
          value
        }
      }) => handleFilterChange(value, false),
      placeholder: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "row",
        children: [/*#__PURE__*/_jsx(UIIcon, {
          className: "m-right-3",
          name: "language",
          size: "xxs"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.country.default"
        })]
      }),
      value: filters.country
    }), guessed && /*#__PURE__*/_jsx(Small, {
      className: "m-top-3",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.guess"
      })
    }), filters.country !== 'ANY' && /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      className: "m-top-6",
      direction: "row",
      children: [/*#__PURE__*/_jsx(UICheckbox, {
        checked: filters.office_location === OfficeLocationType.PHYSICAL,
        className: "m-right-2",
        onChange: () => onFilterChange('office_location', filters.office_location === OfficeLocationType.PHYSICAL ? 'ANY' : OfficeLocationType.PHYSICAL)
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.questionnaire.country.office"
      })]
    })]
  });
}